export const ROUTE_NAMES = {
  CREATE_NEW: 'create-new',
  DRIVERS: 'drivers',
  HOME: 'home',
  INSURANCE_PRODUCTS: 'insurance-products',
  INSURANCE_PROGRAMS: 'insurance-programs',
  PAYMENT: 'payment',
  POLICYHOLDER: 'policyholder',
  UNDERWRITING: 'underwriting',
  VEHICLE_INFORMATION: 'vehicle-information',
};

const BASE_PATHNAME = 'insurance';
export const CREATE_NEW_BASE_PATHNAME = `/worksheet/${ROUTE_NAMES.CREATE_NEW}/${BASE_PATHNAME}`;
export const BASE_EDIT_PATHNAME = '/worksheet/:id(\\d+)';
export const EDIT_BASE_PATHNAME = `${BASE_EDIT_PATHNAME}/${BASE_PATHNAME}`;

const ROUTES = {
  [ROUTE_NAMES.CREATE_NEW]: {
    path: CREATE_NEW_BASE_PATHNAME,
  },
  [ROUTE_NAMES.DRIVERS]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.DRIVERS}`,
  },
  [ROUTE_NAMES.HOME]: {
    path: `${BASE_EDIT_PATHNAME}/${ROUTE_NAMES.HOME}`,
  },
  [ROUTE_NAMES.INSURANCE_PRODUCTS]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.INSURANCE_PRODUCTS}`,
  },
  [ROUTE_NAMES.INSURANCE_PROGRAMS]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.INSURANCE_PROGRAMS}`,
  },
  [ROUTE_NAMES.PAYMENT]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.PAYMENT}`,
  },
  [ROUTE_NAMES.POLICYHOLDER]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.POLICYHOLDER}`,
  },
  [ROUTE_NAMES.UNDERWRITING]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.UNDERWRITING}`,
  },
  [ROUTE_NAMES.VEHICLE_INFORMATION]: {
    path: `${EDIT_BASE_PATHNAME}/${ROUTE_NAMES.VEHICLE_INFORMATION}`,
  },
};

Object.keys(ROUTES).forEach((key) => {
  ROUTES[key].exact ??= true;
});

export { ROUTES };
